import { Print } from '@mui/icons-material';
import { Button } from '@mui/material';
import { usePrint } from 'modules/common';



export type PrintButtonProps = {};

export const FC = () => {
  const {
    print
  } = usePrint();
  return (
    <Button
      sx={{
        '@media print': {
          display: 'none'
        }
      }}
      variant='outlined'
      startIcon={<Print />}
      onClick={() => print()}
    >
      Print
    </Button>
  );
};
